export const modalBoxSx = (theme) => ({
  backgroundColor: theme.palette.background.secondary,
  maxWidth: '330px',
  borderRadius: '2.5%',
  outline: 'none',
});

export const dialogContentSx = {
  paddingTop: 0,
};

export const iconBtnSx = { marginLeft: 'auto', display: 'flex' };
